module.exports = __webpack_public_path__ + "img/Team-EmilyDurham.febfb840.png";